export default __webpack_public_path__ + "static/media/coffee.eac046ae.svg";